'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3d',
  achievement: '成果',
  action: '操作',
  actions: '操作',
  add: '添加',
  'advanced-search': '高级搜索',
  aggregate: '聚合',
  alarm: '警报',
  alert: '警报',
  analytics: '分析',
  announcement: '公告',
  app: '应用程序',
  archive: '存档',
  article: '文章',
  ascend: '升序',
  assistant: '助理',
  attachment: '附件',
  'bar-chart': '条形图',
  blog: '博客',
  book: '书',
  bookmark: '书签',
  bundle: '包',
  calculator: '计算器',
  calendar: '日历',
  camera: '相机',
  capacity: '容量',
  'caret-down': '脱字号下',
  'caret-next': '脱字号后',
  'caret-previous': '脱字号前',
  'caret-up': '脱字号上',
  catalog: '目录',
  'chapter-add': '添加章',
  'chapter-next': '下一章',
  'chapter-previous': '上一章',
  chat: '聊天',
  'checkbox-selected': '复选框选中',
  checkbox: '复选框',
  checkmark: '复选标记',
  'circular-view': '循环视图',
  clipboard: '剪贴板',
  clone: '克隆',
  close: '关闭',
  'cloud-computer': '云计算机',
  'cloud-download': '云下载',
  'cloud-software': '云软件',
  'cloud-upload': '云上载',
  cloud: '云',
  cluster: '群集',
  code: '代码',
  'command-line': '命令行',
  compare: '比较',
  compasss: '罗盘',
  compliance: '合规性',
  'computer-personal': '个人电脑',
  configuration: '配置',
  connect: '连接',
  'contact-card': '名片',
  'contact-us': '联系我们',
  contract: '合同',
  copy: '副本',
  cube: '多维数据集',
  cubes: '多维数据集',
  cursor: '光标',
  cut: '剪切',
  cycle: '周期',
  dashboard: '控制面板',
  database: '数据库',
  defect: '缺陷',
  deliver: '提供',
  deployment: '部署',
  descend: '降序',
  desktop: '桌面',
  detach: '分离',
  directions: '方向',
  dislike: '踩',
  'divide-four': '四分',
  'divide-right': '正确分隔',
  'divide-three': '三分',
  divide: '分隔',
  'document-cloud': '文档云',
  'document-compress': '文档压缩',
  'document-conig': '文档配置',
  'document-csv': 'csv 文档',
  'document-data': '文档数据',
  'document-download': '文档下载',
  'document-excel': 'excel 文档',
  'document-executable': '可执行文档',
  'document-image': '图像文档',
  'document-locked': '文档被锁定',
  'document-missing': '文档丢失',
  'document-notes': '文档注释',
  'document-outlook': 'outlook 文档',
  'document-pdf': 'pdf 文档',
  'document-performance': '文档性能',
  'document-powerpoint': 'powerpoint 文档',
  'document-rtf': 'rtf 文档',
  'document-sound': '声音文档',
  'document-test': '文档测试',
  'document-text': '文本文档',
  'document-threat': '文档威胁',
  'document-time': '文档时间',
  'document-transfer': '文档传输',
  'document-txt': 'txt 文档',
  'document-update': '文档更新',
  'document-upload': '文档上载',
  'document-user': '文档用户',
  'document-verified': '已验证文档',
  'document-video': '视频文档',
  'document-word': 'word 文档',
  document: '文档',
  domain: '域',
  down: '下',
  download: '下载',
  drag: '拖动',
  'drive-cage': '驱动器固定架',
  duplicate: '重复',
  edit: '编辑',
  eject: '弹出',
  expand: '展开',
  fan: '风扇',
  'fast-forward': '快进',
  favorite: '收藏',
  filter: '筛选',
  'first-aid': '急救',
  flag: '标志',
  'folder-cycle': '文件夹循环',
  'folder-open': '文件夹已打开',
  folder: '文件夹',
  gallery: '画廊',
  globe: '全球',
  grid: '网格',
  group: '组',
  grow: '增长',
  halt: '停止',
  help: '帮助',
  history: '历史记录',
  home: '主页',
  'host-maintenance': '主机维护',
  host: '主机',
  image: '图像',
  impact: '影响',
  'in-progress': '正在进行',
  inbox: '收件箱',
  indicator: '指标',
  information: '信息',
  inherit: '继承',
  install: '安装',
  integration: '集成',
  iteration: '迭代',
  java: 'java',
  language: '语言',
  launch: '启动',
  license: '许可',
  like: '赞',
  'line-chart': '折线图',
  'link-bottom': '链接底部',
  'link-down': '链接中断',
  'link-next': '下一个链接',
  'link-previous': '上一个链接',
  'link-top': '链接顶部',
  'link-up': '链接连通',
  link: '链接',
  'location-pin': '定位销',
  location: '位置',
  lock: '锁',
  login: '登录',
  logout: '注销',
  mail: '邮件',
  manual: '手动',
  'map-location': '位置映射',
  map: '地图',
  menu: '菜单',
  microphone: '麦克风',
  monitor: '监控',
  more: '更多',
  multiple: '多个',
  navigate: '导航',
  'new-window': '新窗口',
  new: '新',
  next: '下一步',
  notes: '备注',
  notification: '通知',
  optimization: '优化',
  organization: '组织',
  overlay: '覆盖',
  overview: '概述',
  pan: '平移',
  pause: '暂停',
  'payment-google-wallet': 'google 钱包付款',
  'payment-mastercard': 'mastercard 付款',
  'payment-paypal': 'paypal 付款',
  'payment-square': 'square 付款',
  'payment-visa': 'visa 付款',
  pin: 'PIN',
  plan: '计划',
  'platform-apple': 'apple 平台',
  'platform-chrome': 'chrome 平台',
  'platform-dropbox': 'dropbox 平台',
  'platform-edge': 'edge 平台',
  'platform-firefox': 'firefox 平台',
  'platform-internet-explorer': 'internet explorer 平台',
  'platform-skype': 'skype 平台',
  'platform-windows': 'windows 平台',
  play: '播放',
  power: '电源',
  previous: '上一步',
  print: '打印',
  'quick-view': '快速查看',
  'radial-selected': '径向选择',
  radial: '径向',
  refresh: '刷新',
  resources: '资源',
  rewind: '倒带',
  risk: '风险',
  rss: 'rss',
  satellite: '卫星',
  'schedule-clone': '克隆计划',
  'schedule-new': '新建计划',
  'schedule-play': '播放计划',
  schedule: '计划',
  scorecard: '记分卡',
  search: '搜索',
  secure: '安全',
  'select-left': '选择左侧',
  select: '选择',
  'server-cluster': '服务器群集',
  server: '服务器',
  servers: '服务器',
  'service-business': '服务业务',
  'service-start': '服务启动',
  share: '共享',
  'sheild-configure': '防护配置',
  shield: '防护',
  shift: '转变',
  'shop-basket': '购物篮',
  'shop-cart': '购物车',
  soa: 'soa',
  'social-email': '电子邮件社交',
  'social-facebook': 'facebook 社交',
  'social-github': 'github 社交',
  'social-google': 'google 社交',
  'social-instagram': 'instagram 社交',
  'social-linkedin': 'linkedin 社交',
  'social-medium': 'medium 社交',
  'social-pinterest': 'pinterest 社交',
  'social-reddit': 'reddit 社交',
  'social-slack': 'slack 社交',
  'social-tumblr': 'tumblr 社交',
  'social-twitter': 'twitter 社交',
  'social-vimeo': 'vimeo 社交',
  'social-youtube': 'youtube 社交',
  sort: '排序',
  stakeholder: '利益相关者',
  'star-half': '半星',
  star: '星级',
  steps: '步骤',
  storage: '存储',
  'street-view': '街景',
  subtract: '减去',
  support: '支持',
  svg: 'svg',
  sync: '同步',
  system: '系统',
  'tab-next': '下一个选项卡',
  'tab-previous': '上一个选项卡',
  'tab-up': '上面的选项卡',
  'table-add': '添加表',
  table: '表',
  tag: '标签',
  target: '目标',
  task: '任务',
  template: '模板',
  'test-desktop': '测试桌面',
  test: '测试',
  'tesxt-wrap': '文字环绕',
  threats: '威胁',
  'three-d': '3d',
  ticket: '记录单',
  tools: '工具',
  tooltip: '工具提示',
  transaction: '交易',
  trash: '垃圾',
  tree: '树',
  trigger: '触发',
  trophy: '奖品',
  troubleshooting: '疑难解答',
  unlock: '解锁',
  up: '上',
  update: '更新',
  upgrade: '升级',
  upload: '上载',
  'user-add': '添加用户',
  'user-admin': '管理员用户',
  'user-expert': '专家用户',
  'user-female': '女性用户',
  'user-manager': '用户管理器',
  'user-new': '新用户',
  'user-police': '警察用户',
  'user-settings': '用户设置',
  'user-worker': '工人用户',
  user: '用户',
  validation: '验证',
  video: '视频',
  view: '视图',
  'virtual-machine': '虚拟机',
  'vm-maintenance': '虚拟机维护',
  'volume-low': '音量低',
  'volume-mute': '音量静音',
  volume: '音量',
  vulnerability: '漏洞',
  waypoint: '路径点',
  workshop: '工作室',
  'zoom-in': '放大'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/icons/zh-CN.js
// module id = 127
// module chunks = 0